// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_EXPERIENCE_SENT_TOAST = "Tvoja sk\u00fasenos\u0165 bola odoslan\u00e1. \u010eakujeme!";
